/* eslint-disable */
import { RecipeStage } from '@/Components/Forms/Cooking/Cooking Recipe';
import CookingProcessesTabs from '@/Components/Forms/Cooking/CookingProcessesTabs/CookingProcessesTabs';
import TimeRequired from '../TimeRequired/TimeRequired';

const CookingRecipeStages = (props) => {
	const {
		fields,
		setActiveStage,
		activeStage,
		cookingRecipeConfig,
		activeProcess,
		setActiveProcess,
		totalRequiredTime = null,
		activeStageMappings = [],
		mappingTypeConfig = [],
		storesList = [],
		selectedMappingStoreId,
		onMappingStoreChange,
		isDisabled = true,
		handleInput,
		handleDelete,
		handleProcessReOrdering,
		addNewProcess,
		addDependencies,
		removeDependency,
		handleRecipeDetailsInput,
		handleBatchSize,
		errors,
		batches,
	} = props;
	const activeStageValue = fields.stages.items?.[activeStage];

	return (
		<div className='grid grid-cols-4'>
			<div className='col-span-1'>
				<CookingProcessesTabs
					processes={fields.stages.items}
					activeStage={activeStage}
					setActiveStage={setActiveStage}
				/>
			</div>
			<div
				className={`border-2 border-black p-3 w-full rounded-xl col-span-3 relative`}
				style={{
					background: `${activeStageValue?.process?.color}20`,
					borderColor: activeStageValue?.process?.color,
				}}
			>
				{/* Store Selector + Total Time Row */}
				<div className='flex justify-end items-center absolute top-[-2rem] right-0 gap-2'>
					{storesList?.length > 0 ? (
						<div className='flex items-center gap-1'>
							<label className='text-xs text-gray-500'>Store Recipe Config:</label>
							<select
								value={selectedMappingStoreId ?? ''}
								onChange={(e) => onMappingStoreChange?.(Number(e.target.value))}
								className='text-xs border border-gray-300 rounded px-1 py-[2px] bg-white text-gray-700 cursor-pointer outline-none'
							>
								{storesList.map((store) => (
									<option key={store.id} value={store.id}>
										{store.name}
									</option>
								))}
							</select>
						</div>
					) : <div />}
					{totalRequiredTime && (
						<TimeRequired totalRequiredTime={totalRequiredTime} />
					)}
				</div>
				<RecipeStage
					handleInput={handleInput}
					handleDelete={handleDelete}
					activeStage={activeStage}
					stageDetails={fields.stages.items[activeStage] ?? {}}
					mandatoryFields={cookingRecipeConfig.mandatoryFields}
					errors={errors}
					activeProcess={activeProcess}
					setActiveProcess={setActiveProcess}
					handleProcessReOrdering={handleProcessReOrdering}
					addNewProcess={addNewProcess}
					stages={fields.stages}
					addDependencies={addDependencies}
					removeDependency={removeDependency}
					defaultVariant={fields.product.defaultVariant}
					allVariants={fields.product.variants}
					handleRecipeDetailsInput={handleRecipeDetailsInput}
					handleBatchSize={handleBatchSize}
					isDisabled={isDisabled}
					activeStageMappings={activeStageMappings}
					mappingTypeConfig={mappingTypeConfig}
					batches={batches}
					selectedMappingStoreId={selectedMappingStoreId}
				/>
			</div>
		</div>
	);
};

export default CookingRecipeStages;
